import { render, staticRenderFns } from "./ProfessionalAccessComponent.vue?vue&type=template&id=95bf8668"
import script from "./ProfessionalAccessComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfessionalAccessComponent.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95bf8668')) {
      api.createRecord('95bf8668', component.options)
    } else {
      api.reload('95bf8668', component.options)
    }
    module.hot.accept("./ProfessionalAccessComponent.vue?vue&type=template&id=95bf8668", function () {
      api.rerender('95bf8668', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/maintenance/Users/components/ProfessionalAccessComponent.vue"
export default component.exports